import { render, staticRenderFns } from "./FadeUpImage.vue?vue&type=template&id=74c406e2&scoped=true&functional=true"
var script = {}
import style0 from "./FadeUpImage.vue?vue&type=style&index=0&id=74c406e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "74c406e2",
  null
  
)

export default component.exports